import { StoreContext } from '../../../configuration/StoreContext';
import { observable, reaction, action, computed } from 'mobx';
import { StoreBase } from '../../../common/StoreBase';
import { GetApplicationAppConfig } from '@kurtosys/ksys-api-client/dist/requests/root/GetApplicationAppConfig';
import { IRequestOptions } from '@kurtosys/ksys-api-client/dist/models/IRequestOptions';
import { ListApplications } from '@kurtosys/ksys-api-client/dist/requests/applicationManager/ListApplications';
import { Initialize } from '@kurtosys/ksys-api-client/dist/requests/apps/Initialize';

export class KurtosysApiStore extends StoreBase {
	constructor(storeContext: StoreContext) {
		super(storeContext);
	}

	@computed
	get getAppConfig(): GetApplicationAppConfig {
		return new GetApplicationAppConfig(this.wrappedToken, this.options);
	}

	@computed
	get listApplications(): ListApplications {
		return new ListApplications(this.wrappedToken, this.options);
	}

	@computed
	get initializeApps(): Initialize {
		return new Initialize(this.wrappedToken, this.options);
	}

	@action
	async initialize(): Promise<void> {

	}

	@observable token: string = '';
	@computed
	get wrappedToken(): { value: string } {
		return { value: this.token };
	}
	@computed
	get options(): IRequestOptions<any> {
		const { appStore } = this.storeContext;
		const serviceUrl = appStore.configuration && appStore.configuration.core && appStore.configuration.core.serviceUrl;
		return {
			baseUrl: serviceUrl || this.getBaseAddress(),
		};
	}
	getBaseAddress(suffix: string = 'services/') {
		return this.manifest.getBaseUrl(suffix);
	}

}